import { render, staticRenderFns } from "./StudentsEditDocuments.vue?vue&type=template&id=04befe91&scoped=true"
import script from "./StudentsEditDocuments.vue?vue&type=script&lang=js"
export * from "./StudentsEditDocuments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04befe91",
  null
  
)

export default component.exports